import { Tag } from "@fanduel/formation-react-components";
import TeamPlayerAvatar from "@/components/teamPlayerAvatar";
import { PositionAbbrev } from "@/graphql/gql/graphql";
import ViewGameLog from "./viewGameLog";
import styles from "./playerCell.module.scss";

interface PlayerCellProps {
  name: string;
  numberFirePlayerId: number;
  position: string;
  jerseyNumber: string | number;
  jerseyLogoSrc: string;
  teamLogoSrc: string;
  teamShortCode: string;
}

export default function PlayerCell(props: PlayerCellProps) {
  const {
    name,
    numberFirePlayerId,
    position,
    jerseyNumber,
    jerseyLogoSrc,
    teamLogoSrc,
    teamShortCode,
  } = props;

  const displayName = position === PositionAbbrev.D ? `${name} Defense` : name;

  return (
    <div className={styles.cell}>
      <TeamPlayerAvatar
        primaryImgName={`${teamShortCode} Jersey Logo`}
        primaryImgUrl={jerseyLogoSrc}
        primaryImgSize={60}
        secondaryImgName={`${teamShortCode} Team Logo`}
        secondaryImgUrl={teamLogoSrc}
        secondaryImgSize={28}
      />
      <div className={styles.playerDesc}>
        <div className={styles.nameLine}>
          <Tag>{position}</Tag>
          {/* When this is converted to a link include the amplitude Head To Head Player Link Clicked event */}
          <span className={styles.playerName}>{displayName}</span>
        </div>
        <div>
          {position !== PositionAbbrev.D &&
            `${teamShortCode} • #${jerseyNumber}`}
        </div>
        <ViewGameLog
          numberFirePlayerId={numberFirePlayerId}
          playerName={name}
        />
      </div>
    </div>
  );
}
